
import { Module } from 'vuex'

import { ChatRoomController } from '../../controller'

import { MessengerState } from '..'

export interface ChatRoomControllerState {
  controllers: ChatRoomController[]
}

const ChatRoomControllerModule: Module<ChatRoomControllerState, MessengerState> = {
  namespaced: true,
  state: {
    controllers: [],
  },
  getters: {
    controller: (state) => (chatRoomId: number) => state.controllers.find((i) => i.chatRoomId == chatRoomId),
  },
  mutations: {
    addController (state, controller: ChatRoomController) {
      state.controllers.push(controller)
    },
    removeController (state, chatRoomId: number) {
      state.controllers = state.controllers.filter((i) => i.chatRoomId != chatRoomId)
    },
  },
}

export default ChatRoomControllerModule